// extracted by mini-css-extract-plugin
module.exports = {"Header":"DesiredTimeWindows_Header__2wxLN"};